import React from "react";

export default function WaveformVisualizer({ level = 0, active = false, accent = "indigo" }) {
  const barClass = { indigo: "bg-indigo-400", teal: "bg-teal-400", fuchsia: "bg-fuchsia-400" }[accent] || "bg-indigo-400";
  const bars = [0.6, 1, 0.85, 1.1, 0.7];
  return (
    <div className="flex items-center justify-center gap-1 h-10" data-testid="mic-waveform">
      {bars.map((mult, i) => (
        <div
          key={i}
          className={`w-1.5 rounded-full transition-all duration-100 ${barClass} ${active ? "opacity-100" : "opacity-25"}`}
          style={{ height: `${Math.max(6, level * 36 * mult + 6)}px` }}
        />
      ))}
    </div>
  );
}
